/*
Nuts
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Nuts'
const id = 'bbS7TpQyBO1hSMKwhkfa'

export default {
  name,
  id,
  filters,
  headers,
  form
}
